import { styled } from "@mui/material/styles";
import { ToggleButtonGroup } from "@mui/material";
import { Box } from '@mui/material';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    "& .MuiToggleButton-root": {
      color: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      textTransform: "none",
      fontSize: "0.875rem",
      padding: theme.spacing(1, 2),
      transition: theme.transitions.create(
        ["color", "background-color", "border-color"],
        {
          duration: theme.transitions.duration.short,
        }
      ),
      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
);

export const ToggleContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1),
  '& .MuiToggleButtonGroup-root': {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    '& .MuiToggleButton-root': {
      color: theme.palette.text.primary,
      '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  },
}));
